export default {
  playBooks: [],
  playBook: undefined,
};
